import colors from '../styles/Color.scss';
import themeGlobalConfig from './themeGlobalConfig';

const themeLightConfig = {
  colorPrimary: colors.primaryColor,
  colorLink: colors.primaryColor,
  colorText: colors.primaryText,
  token: {
    ...themeGlobalConfig.token,
    colorPrimaryText: colors.whiteColor,
    colorTextSecondary: colors.secondaryText,
    colorBorder: colors.borderColor,
    colorBgLayout: colors.bg,
    colorErrorBgHover: colors.dangerActive,
    colorLink: colors.linkColor,
    colorLinkHover: colors.linkHover,
    colorLinkActive: colors.linkHover,
  },
  components: {
    ...themeGlobalConfig.components,
    Layout: {
      ...themeGlobalConfig.components.Layout,
      bodyBg: colors.bg,
    },
    Menu: {
      ...themeGlobalConfig.components.Menu,
      itemSelectedBg: 'rgba(255,255,255,0.14901960784313725)',
      itemHoverBg: 'rgba(255,255,255,0.14901960784313725)',
    },
    Input: {
      ...themeGlobalConfig.components.Input,
      colorBorder: colors.googleAutocompleteGray,
    },
    InputNumber: {
      ...themeGlobalConfig.components.InputNumber,
      colorBorder: colors.googleAutocompleteGray,
    },
    Select: {
      ...themeGlobalConfig.components.Select,
      colorBorder: colors.googleAutocompleteGray,
    },
    DatePicker: {
      ...themeGlobalConfig.components.DatePicker,
      colorBorder: colors.googleAutocompleteGray,
    },
    Table: {
      ...themeGlobalConfig.components.Table,
      headerBg: colors.whiteColor,
      headerColor: colors.tableHeaderColor,
      rowHoverBg: colors.diffGrayBlue,
      borderColor: colors.tableBorder,
    },
    Divider: {
      ...themeGlobalConfig.components.Divider,
      colorSplit: colors.whiteGrayColor,
    },
  },
};

export default themeLightConfig;
